module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.goodsList), function(goods, index) {
    return _c('div', {
      staticClass: "coms-goods flex-start",
      on: {
        "click": function($event) {
          return _vm.goGoodsDetail(goods)
        }
      }
    }, [_c('img', {
      staticClass: "coms-left",
      attrs: {
        "src": goods.pic_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "coms-right"
    }, [_c('div', {
      staticClass: "coms-good-name"
    }, [_vm._v(_vm._s(goods.title))]), _vm._v(" "), _c('div', {
      staticClass: "coms-good-detail"
    }, [_c('div', {
      staticClass: "flex-start"
    }, [_c('div', {
      staticClass: "scroll-goods-price"
    }, [_c('div', {
      staticClass: "goods-list0-price"
    }, [_vm._v("¥")]), _vm._v(" "), _c('div', {
      staticClass: "goods-list1-price"
    }, [_vm._v(_vm._s(_vm._f("price")(goods.price_range[0])))])]), _vm._v(" "), (goods.max_seller_reward > 0) ? _c('div', {
      staticClass: "scroll-goods-item0-seller-price",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_c('div', {
      staticClass: "fan"
    }, [_vm._v("赚")]), _vm._v(" "), _c('div', {
      staticClass: "seller-price"
    }, [_vm._v("¥" + _vm._s(goods.max_seller_reward))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "coms-sold"
    }, [_c('div', {
      staticClass: "coms-sell-num"
    }, [_vm._v("已售 " + _vm._s(goods.sold_count + goods.sold_show_count))]), _vm._v(" "), _c('div', {
      staticClass: "good-thr-price"
    }, [_vm._v("\n                ¥" + _vm._s(goods.orig_price) + "\n            ")])])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ebda80a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoodsItem1.vue
// module id = 2608
// module chunks = 0